module.exports = __webpack_public_path__ + "img/yijian.a0d9a7ae.png";